<div class="export-settings" data-automation-id="export-settings-container">
    <div class="header-bar" data-automation-id="export-settings-header">
        <button type="button" data-automation-id="export-settings-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isSaveDisabled()" *ngIf="hasCreatePermissions">Save</button>
        <button type="button" data-automation-id="export-settings-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDiscardDisabled()" *ngIf="hasCreatePermissions">Discard
            Changes</button>
        <button type="button" class="help-button" data-automation-id="export-settings-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>

    <div class="scrollable-area">
        <form class="content" #contentForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage"
            data-automation-id="export-settings-content">
            <div class="panels-container" *ngIf="isExportDataLoaded">
                <div class="left-settings-panel">
                    <div class="settings-panel-header">File Output Options</div>
                    <div class="modal-row bottom-space">
                        <div class="modal-row-column-auto column-left-text">
                            <label requiredAsterisk [class.disabled]="!hasCreatePermissions">Documents per Folder:
                            </label>
                        </div>
                        <div class="modal-row-column-auto auto-expand">
                            <input type="number" name="folderSize"
                                [(ngModel)]="viewModel.model.exportSettingsOptions.folderSize"
                                data-automation-id="export-settings-documents-per-folder-input"
                                class="matter-input-width" (ngModelChange)="onChange()"
                                [disabled]="!hasCreatePermissions">
                        </div>
                    </div>
                    <div class="settings-panel-header">Other</div>
                    <div class="modal-row" *ngIf="isProjectSettings">
                        <div class="modal-row-column-auto column-left-text">
                            <label [class.disabled]="!hasCreatePermissions || isSystemSettingsContext">Export Database:
                            </label>
                        </div>
                        <div class="modal-row-column-auto auto-expand export-db-class">
                            <select name="selectedExportDatabaseConnection_settings"
                                [title]="isSystemSettingsContext? 'Export Database selection does not apply at the System template level' : ''"
                                automationId="export-settings-selected-export-database-connection"
                                class="selected-export-database-connection"
                                [(ngModel)]="viewModel.model.exportSettingsOptions.exportDatabaseConnectionHandle"
                                (ngModelChange)="onChange($event)"
                                [disabled]="!hasCreatePermissions || isSystemSettingsContext">

                                <option [ngValue]="''"></option>

                                <option *ngFor="let c of exportDatabaseConnections; trackBy: trackByHandle"
                                    [ngValue]="c.handle">
                                    {{ c.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-row" *ngIf="isProjectSettings">
                        <div class="modal-row-column-auto column-left-text">
                            <label [class.disabled]="!hasCreatePermissions">Volume Encryption Key:
                            </label>
                        </div>
                        <div class="modal-row-column-auto auto-expand">
                            <input type="text" name="volumeEncryptionKey" [(ngModel)]="viewModel.model.exportSettingsOptions.postProcessKey"
                                [value]="viewModel.model.exportSettingsOptions.postProcessKey"
                                data-automation-id="export-settings-volume-encryption-key-input"
                                class="matter-input-width" (ngModelChange)="onChange()"
                                [disabled]="!hasCreatePermissions">
                        </div>
                    </div>
                    <div class="modal-row">
                        <div class="modal-row-column-auto max-width-full">
                            <res-custom-checkbox name="exportNearDupeNumericsIncluded"
                                automationId="export-settings-export-near-dupe-numerics-included"
                                [(ngModel)]="viewModel.model.exportSettingsOptions.exportNearDupeNumericsIncluded"
                                content="Include numeric values in near-duplicate processing"
                                (ngModelChange)="onChange()" [isDisabled]="!hasCreatePermissions">
                            </res-custom-checkbox>
                            <res-custom-checkbox name="exportExtensionConversionEnabled"
                                automationId="export-settings-export-extension-conversion-enabled"
                                [(ngModel)]="viewModel.model.exportSettingsOptions.exportExtensionConversionEnabled"
                                content="Enable file extension correction" (ngModelChange)="onChange()"
                                [isDisabled]="!hasCreatePermissions"></res-custom-checkbox>
                            <res-custom-checkbox name="exportVolumesAllowed" *ngIf="isProjectSettings"
                                automationId="show-export-dialog-for-export-to-relativity"
                                [(ngModel)]="viewModel.model.exportSettingsOptions.exportVolumesAllowed"
                                [content]="'Show Export dialog for Export to ' + exportToTitle"
                                (ngModelChange)="onChange()" [isDisabled]="!hasCreatePermissions"></res-custom-checkbox>
                        </div>
                    </div>
                </div>
                <div class="right-settings-panel">
                    <div class="settings-panel-header">Image Exceptions</div>
                    <div class="key-value-list-container"
                        [attr.data-automation-id]="'export-settings-image-exceptions-container'">
                        <res-key-value-list [placeholderField1]='"Search Name ..."'
                            [placeholderField2]='"Search Query ..."'
                            [rows]="viewModel.model.exportSettingsOptions.exportImageExceptionsSet"
                            automationId="export-settings-image-exceptions-"
                            [attr.data-automation-id]="'export-settings-image-exceptions-key-value-list'"
                            [excludeTrashBtnFromTabIndex]="true" [validateName]="true" [maxNameLength]="100"
                            [maxQueryLength]="1024" [isDisabled]="!hasCreatePermissions"
                            [isQueryValidationContext]="true" [settingsType]="settingsType">
                        </res-key-value-list>
                    </div>
                </div>
            </div>
            <div class="export-panel" data-automation-id="export-modal-modal-container" *ngIf="isExportDataLoaded">
                <res-export [automationId]="'export-modal'" [isExportSettingsPage]="isExportSettingsPage"
                    [exportSettingsOptions]="exportSettingsOptions" (dirtyStateChanged)="onExportDirtyStateChanged($event)"
                    [isProjectSettings]="isProjectSettings"></res-export>
            </div>
        </form>
    </div>